<template>
    <div class="flex w-full justify-center px-8 sm:px-20 py-32 md:py-12">
      <div class="w-full max-w-2xl lg:max-w-4xl text-ihh-slate-gray space-y-4 leading-8 text-base">
        <div class="flex w-full justify-center text-ihh-midnight-gray font-semibold text-3xl text-center mb-8">
          What to do if your package is lost?
        </div>
         <div>If your order tracking shows your package as delivered but you have not received it here are some tips to speedily locating your order:</div>
         <ol class="list-decimal pl-6">
           <li>Check your order details to ensure the correct address was entered when the order was placed.</li>
           <li>Check with anyone else who was at the delivery location at the time of delivery and see if they received your package.</li>
           <li>If you live at an address where packages are left in a parcel locker or main complex office please check there as well.</li>
           <li>Check alternate doors or areas where delivery drivers may have left your package.</li>
         </ol>
         <div>Still can't find your package? <a href="/help-center" class="text-ihh-dark-salmon hover:text-ihh-salmon font-semibold underline underline-offset-2">Contact us</a></div>
         <div>We will start an investigation and reach out to the carrier to determine where your package is. We apologize for the inconvenience.</div>
         <div>We may be unable to replace lost packages that are not reported within 3 days of being scanned as delivered. <span class="font-semibold">In His Hands is not responsible for addresses submitted incorrectly.</span></div>
      </div>
    </div>
</template>
